import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { ReactComponent as IconArrowRight } from '../../assets/icon/ic_arrow_right.svg';
import { ReactComponent as IconArrowDown } from '../../assets/icon/ic_arrow_down.svg';

const NavMenuItem = ({
  item: {
    list, path, Icon, title
  },
  submenu,
  onClick,
  isOpen,
  isActive,
  isCollapsed,
  showLabel
}) => {
  const collapsedAlignment = submenu ? 'justify-start' : 'justify-between md:justify-center';
  const baseClasses = `
    transition-all duration-300 ease-out flex flex-row items-center
    text-[#6b7280] dark:text-[#778da9]
    px-[20px] md:px-[25px] py-[11px] md:py-[10px] hover:cursor-pointer
    hover:bg-[#f1f5f9] dark:hover:bg-[#415a77]
    ${isCollapsed ? collapsedAlignment : 'justify-between'}
  `;
  const activeClasses = 'bg-[#f1f5f9] text-[#111827] dark:bg-[#415a77] dark:text-white';
  const submenuClasses = isCollapsed ? 'pl-[45px] md:pl-[25px]' : 'pl-[45px]';
  const iconClasses = [
    'transition-all duration-300 ease-out flex w-[20px] h-[20px] mr-[10px]',
    'text-[#94a3b8] dark:text-[#778da9]'
  ].join(' ');
  const iconActiveClasses = 'text-primary';
  const titleClasses = 'text-[#111827] dark:text-white';
  const shouldShowLabel = showLabel || !isCollapsed;
  const labelClassName = shouldShowLabel ? '' : 'md:hidden';
  const arrowClassName = shouldShowLabel ? '' : 'md:hidden';

  // eslint-disable-next-line react/prop-types
  const Div = ({ children }) => (
    <div
      onClick={onClick}
      className={`${baseClasses} ${isActive ? activeClasses : ''}`}
      role="presentation"
    >
      {children}
    </div>
  );
  const Container = path ? NavLink : Div;
  const ArrowIcon = isOpen ? IconArrowDown : IconArrowRight;
  return (
    <Container
      to={path}
      className={
        ({ isActive: isA }) => {
          return `${baseClasses} ${isA ? activeClasses : ''} ${submenu ? submenuClasses : ''}`;
        }
      }
      onClick={onClick}
    >
      <div className="flex flex-row items-center">
        <div className="flex justify-center items-center">
          {
            Icon
              ? <Icon className={`${iconClasses} ${isActive ? iconActiveClasses : ''}`} />
              : <div className="w-[5px] h-[5px] rounded-full bg-[#94a3b8] dark:bg-[#9899ac] mr-[10px]" />
          }
        </div>
        <div className={`${isActive ? titleClasses : ''} ${labelClassName}`}>{title}</div>
      </div>
      <div className={arrowClassName}>
        {list && <ArrowIcon className={`${iconClasses} ${isActive ? iconActiveClasses : ''}`} />}
      </div>
    </Container>
  );
};

NavMenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({})),
    path: PropTypes.string,
    title: PropTypes.string,
    Icon: PropTypes.shape({}),
  }),
  submenu: PropTypes.bool,
  isOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  showLabel: PropTypes.bool,
  onClick: PropTypes.func,
};

NavMenuItem.defaultProps = {
  item: {
    list: undefined,
    path: '',
    title: '',
    Icon: undefined,
  },
  submenu: false,
  isOpen: false,
  isActive: false,
  isCollapsed: false,
  showLabel: false,
  onClick: () => {},
};

export default NavMenuItem;
